import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

export const ForwardSendIcon = ({ sx, ...props }: { sx?: SxProps }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', ...sx }}
    {...props}
  >
    <path
      fill="#fff"
      d="m12.651 12.158-6.025 1.005a.4.4 0 0 0-.309.254L4.24 18.983a.6.6 0 0 0 .828.754l14.4-7.2a.6.6 0 0 0 0-1.073l-14.4-7.2a.6.6 0 0 0-.828.754l2.078 5.566a.4.4 0 0 0 .31.255l6.024 1.004a.16.16 0 0 1 0 .315Z"
    />
  </SvgIcon>
)

ForwardSendIcon.defaultProps = {
  sx: {},
}
